import { IImage } from '@interfaces/IImage';

export enum FileType {
  Image = 'IMAGE',
  Video = 'VIDEO',
}

interface FileVideo {
  fileType: FileType.Video;
  width: number;
  height: number;
  url: string;
  image?: IImage;
  fileId: string;
  extension: string;
}

interface FileImage {
  fileType: FileType.Image;
  image: IImage | null;
}

type MediaFile = FileVideo | FileImage;

export default MediaFile;
